export default __webpack_public_path__ + "static/media/Medium.e22af19d.svg";